// extracted by mini-css-extract-plugin
export default {"container":"failure_container__NPbkA","transation":"failure_transation__6Cmla","status":"failure_status__xso2k","content":"failure_content__SiiVG","button":"failure_button__9Q8ps"};